import { toast } from "sonner";
import { logError, addBreadcrumb } from "./errorLogger";

// iter 429 — Jake: "log every … toast notification". Error/warning toasts
// become error_logs rows (they're what users actually see go wrong);
// success/info toasts are kept as breadcrumbs so a crash shows what the
// user was told right before. Patches the shared sonner `toast` object
// once at boot, so all 800+ call sites are covered without edits.

function textOf(msg) {
  if (msg == null) return "";
  if (typeof msg === "string") return msg;
  if (typeof msg === "number") return String(msg);
  try {
    if (msg?.props?.children) {
      const c = msg.props.children;
      return Array.isArray(c) ? c.filter((x) => typeof x === "string").join(" ") : String(c);
    }
  } catch { /* ignore */ }
  return "[custom toast]";
}

export function installToastLogger() {
  if (toast.__dispatchLogged) return;
  const wrapLogged = (level, orig) => (msg, opts) => {
    try {
      const text = textOf(msg).slice(0, 300);
      const description = typeof opts?.description === "string" ? opts.description.slice(0, 300) : undefined;
      addBreadcrumb(`toast_${level}`, text);
      logError({
        action: `toast_${level}`,
        source: "toast",
        error: { message: text || `[${level} toast]` },
        extra: description ? { description } : undefined,
      });
    } catch { /* never block the toast */ }
    return orig(msg, opts);
  };
  const wrapCrumb = (level, orig) => (msg, opts) => {
    try { addBreadcrumb(`toast_${level}`, textOf(msg)); } catch { /* ignore */ }
    return orig(msg, opts);
  };
  toast.error = wrapLogged("error", toast.error.bind(toast));
  toast.warning = wrapLogged("warning", toast.warning.bind(toast));
  for (const level of ["success", "info", "message", "loading"]) {
    if (typeof toast[level] === "function") toast[level] = wrapCrumb(level, toast[level].bind(toast));
  }
  toast.__dispatchLogged = true;
}
